import React from 'react';
import { Section, Card } from '../hospital/shared/primitives';
import { LinkRow, IntroRow } from '../shared/ListRows';
import { Mail } from 'lucide-react';

const ACCENT = '#0369a1';

/*
 * Department contacts. Entries still to be confirmed are left out rather than shown as
 * placeholders; a group with nothing confirmed shows one line saying so.
 */
const GROUPS = [
  { title: 'Leadership', contacts: [
    ['Dr. James Anton', 'Chair, Department of Anesthesiology', 'anton@bcm.edu'],
  ] },
  { title: 'Residency program', contacts: [
    ['Dr. Lee Chang', 'Program Director', 'lcchang@bcm.edu'],
    ['Dr. Susan Lee', 'Associate Program Director', 'scl@bcm.edu'],
    ['Dr. Chris Deng', 'Associate Program Director', 'chris.deng@bcm.edu'],
    ['Dr. Liz Rossmann-Beel', 'Assistant Program Director', 'rossmann@bcm.edu'],
    ['Dr. Thomas Powell', 'Assistant Program Director', 'tpowell@bcm.edu'],
    ['Alicia Viney', 'Residency Program Coordinator', 'viney@bcm.edu'],
  ] },
  { title: 'Chief residents', contacts: [
    ['Dr. Charlie Burke', 'Chief Resident', 'charles.burke@bcm.edu'],
    ['Dr. Connor Johnson', 'Chief Resident', 'connor.johnson@bcm.edu'],
    ['Dr. Kayli Kallina', 'Chief Resident', 'kayli.kallina@bcm.edu'],
  ] },
  { title: 'Fellowship directors', contacts: [
    ['Dr. Daniel Tolpin', 'Cardiac Anesthesiology Fellowship', 'dtolpin@bcm.edu'],
  ], note: 'Pediatric, critical care and obstetric fellowship directors to be added.' },
  { title: 'Site directors', contacts: [], note: 'Site directors for each rotation to be added. Until then, each hospital page lists its own contacts.' },
  { title: 'Administration', contacts: [
    ['Megan Watts', 'Senior Department Administrator', 'megan.watts@bcm.edu'],
    ['Darryl Robertson', 'Financial Administrator', 'darryl.robertson@bcm.edu'],
  ] },
];

const BCMAnesthesiologyContacts = () => (
  <div className="space-y-6">
    <Card>
      <IntroRow icon={Mail} accent={ACCENT}>
        Department contacts for residents and fellows. During a rotation, clinical questions go to the attending on service and the contacts on that hospital's page.
      </IntroRow>
    </Card>
    {GROUPS.map((g) => (
      <Section key={g.title} title={g.title}>
        <Card>
          {g.contacts.map(([name, role, email]) => <LinkRow key={email} title={name} subtitle={role} href={`mailto:${email}`} />)}
          {g.note && <div className="px-4 py-3 text-xs text-gray-400 dark:text-gray-500">{g.note}</div>}
        </Card>
      </Section>
    ))}
  </div>
);

export default BCMAnesthesiologyContacts;
